













import { defineComponent } from 'vue';
import type { Source } from '@/data';
import { ImageLikeSource } from '@/data/Source';

export default defineComponent({
  name: 'CanvasSourceScore',
  props: {
    source: {
      type: Object as () => Source,
      required: true,
    },
  },
  setup(props) {
    const topMargin = ImageLikeSource.TOTAL_MARGIN;
    return { topMargin };
  },
});
